export enum CheckType {
  Email = 'email',
  UserId = 'userId',
}

export enum ResultType {
  Yes = 'yes',
  No = 'no',
  Unknown = 'unknown',
  Error = 'error',
}
